import { combineKeys, queryKey } from '../../../utils/queryUtils';
import { bookmarksKey } from '../me/bookmarks/keys';
import { subscribedProductsKey } from '../me/products/keys';
import { providersKey } from '../me/providers/keys';
import { recordingsKey } from '../recordings/keys';
import { FetchAssetOptions, FetchTitleOptions } from './api';

export const titleKeys = {
  all: ['title'] as const,
  searchTitles: ['titles-search'] as const,
  series: ['series'] as const,
  suggest: ['suggest'] as const,
  masterId: (id: string) => [...titleKeys.all, id] as const,
  searchResults: (query: string) =>
    [...titleKeys.searchTitles.map((key) => key.toLowerCase()), query.toLowerCase()] as const,
  suggestString: (str: string) => [...titleKeys.suggest.map((word) => word.toLowerCase()), str.toLowerCase()] as const,
};

export const titleKey = queryKey('title', (id: string, options?: FetchTitleOptions) => {
  const opts = options ? Object.values(options).filter(Boolean) : [];
  return [id, ...opts];
});

export const assetKey = combineKeys((id: string, options: FetchAssetOptions) => {
  return [titleKey(id, options), providersKey(), recordingsKey(), subscribedProductsKey(), bookmarksKey()];
});
